import { render, staticRenderFns } from "./MT5.vue?vue&type=template&id=86ad56a4&scoped=true"
import script from "./MT5.vue?vue&type=script&lang=js"
export * from "./MT5.vue?vue&type=script&lang=js"
import style0 from "./MT5.vue?vue&type=style&index=0&id=86ad56a4&prod&scoped=true&lang=css"
import style1 from "./MT5.vue?vue&type=style&index=1&id=86ad56a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ad56a4",
  null
  
)

export default component.exports